import _ from "lodash"
import * as Types from "../index"

import {
  MdRemoveCircleOutline as IcoRm,
  MdAddCircleOutline as IcoPlus,
} from "react-icons/md"

import TypeNestedMultiField from "./TypeNestedMultiField"

import styles from "../../../styles/Form-MultiBlock.module.css"
import { classNames } from "primereact/utils"

export default function MFBuilder(props) {
  const {
    arrayHelpers,
    fields,
    mfDefinition,
    mfFieldName,
    mfLength,
    mfIndex,
    enterprise_id,
    organization_id,
  } = props

  const handleMFTypes = () =>
    _.map(fields, (field, index) => {
      if (field.field_type === "multi_field_nested") {
        return (
          <TypeNestedMultiField
            key={field.field_name}
            field={field}
            mfIndex={mfIndex}
            mfFieldName={mfFieldName}
            index={index}
            enterprise_id={enterprise_id}
            organization_id={organization_id}
          />
        )
      }
      const newProps = {
        type: "multi-field",
        field,
        mfIndex,
        mfFieldName,
        enterprise_id,
        organization_id,
      }
      switch (field.field_type) {
        case "hidden":
          return <Types.TypeHidden {...newProps} key={field.field_name} />
        case "sys":
          return <Types.TypeSys {...newProps} key={field.field_name} />
        case "checkbox":
          return <Types.TypeCheckbox {...newProps} key={field.field_name} />
        case "date":
          return <Types.TypeDate {...newProps} key={field.field_name} />
        case "dropdown":
          return <Types.TypeDropdown {...newProps} key={field.field_name} />
        case "dropdown_us_states":
          return (
            <Types.TypeDropdownUsState {...newProps} key={field.field_name} />
          )
        case "email":
          return <Types.TypeEmail {...newProps} key={field.field_name} />
        case "monthpicker":
          return <Types.TypeMonthpicker {...newProps} key={field.field_name} />
        case "multi_field":
          return <Types.TypeMultiField {...newProps} key={field.field_name} />
        case "text":
          return <Types.TypeText {...newProps} key={field.field_name} />
        case "textarea":
          return <Types.TypeTextarea {...newProps} key={field.field_name} />
        case "time":
          return <Types.TypeTime {...newProps} key={field.field_name} />
        case "number":
          return <Types.TypeNumber {...newProps} key={field.field_name} />
        case "password":
          return <Types.TypePassword {...newProps} key={field.field_name} />
        case "radio":
          return <Types.TypeRadio {...newProps} key={field.field_name} />
        case "phone":
          return <Types.TypeTel {...newProps} key={field.field_name} />
        case "url":
          return <Types.TypeUrl {...newProps} key={field.field_name} />
        case "zipcode":
          return <Types.TypeZipcode {...newProps} key={field.field_name} />
        case "file":
          return <Types.TypeFile {...newProps} key={field.field_name} />
        case "file_image":
          return <Types.TypeFileImage {...newProps} key={field.field_name} />
        case "participant_email_account":
          return (
            <Types.TypeParticipantEmail {...newProps} key={field.field_name} />
          )
        case "button_selector":
          return <Types.TypeButtonSelector {...newProps} key={field.field_name} />
        default:
          return null
      }
    })
  return (
    <div className={classNames(styles.block, "flex flex-column gap-3")}>
      {handleMFTypes()}
      <div className={styles.actions}>
        <IcoPlus onClick={() => arrayHelpers.insert(mfIndex, mfDefinition)} />
        {mfLength > 1 && <IcoRm onClick={() => arrayHelpers.remove(mfIndex)} />}
      </div>
    </div>
  )
}
